export class DataSource {
    public TotalRecords: number;
    public TotalFilteredRecords: number;
    public Sum: number;
    public Data: Array<any>;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/datasource.ts
 **/